import { createContext } from 'react';

import { BrandConfiguration } from '../interfaces';

export const BrandContext = createContext<BrandConfiguration | null>(null);
